// 📋 FSD Entity-scoped i18n - User Entity
// User entity i18n resources
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import koUser from '../locales/ko/user.json';
import enUser from '../locales/en/user.json';
import jaUser from '../locales/ja/user.json';
var USER_NAMESPACE = 'user';
export var userResources = {
    ko: _define_property({}, USER_NAMESPACE, koUser),
    en: _define_property({}, USER_NAMESPACE, enUser),
    ja: _define_property({}, USER_NAMESPACE, jaUser)
};
export { USER_NAMESPACE };
